
import styles from "./PartWorkAdminUsed.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from "react";

import PartWorkItemAdminUse from './components/PartWorkItemAdminUse';
import { getTestUserDetailData, StartTestUser, getTestUser } from "service/TestService";
import { useLocation, useNavigate } from 'react-router-dom'
import userInfo from "utils/userInfo";
import { Button, Layout } from "components";
import moment from 'moment';
import Moment from 'react-moment'
import Notification from "utils/Notifications";

const PartWorkUsed = ({setShowUserInfoForm, data, usedata, setRender}) => {
  const { t } = useTranslation('common')


  

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });


  const formatDate = (dateString) => {
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();

    if (date.isSame(today, 'day')) {
      return date.format('Сегодня HH:mm');
    }
    else if (date.isSame(today, 'year')) {
      return date.format('DD MMMM HH:mm')
    }
    else {
      return date.format('DD MMMM YYYY HH:mm');
    }
  };

  return (

      <div className={styles.test_card}>
        <div style={{ display: 'flex', alignItems: 'start', flexDirection: 'column', justifyContent: 'start', width: '100%' }}>
          <div className={styles["test-app"]}>
           
            <Button
              className={styles.open_btn}
              onClick={() => setShowUserInfoForm(null)}
            >
              Вернуться
            </Button>
          </div>
          <div className={styles.answer_header_selections}>
            <div>
            
            
           

                <span><h4 style={{display:'flex', alignItems:'end', justifyContent:"center"}}>{t('tasks.result')}</h4> <span style={{display:'flex', alignItems:'end', justifyContent:"center", fontSize:'22px'}}><h1>{usedata?.points}</h1></span></span>
            </div>
            
          </div>
        </div>
    
  
        
          <>
            {data?.map((item, index) =>
              <PartWorkItemAdminUse
                item={item}
                item_selected={usedata?.userusetest_employee_tests
                  ?.filter(testItem => testItem.part === item.id || 0)
                  ?.map(filteredItem => filteredItem.part || "Default Value")}
                item_selected_data={usedata?.userusetest_employee_tests
                  ?.filter(testItem => testItem.part === item.id)  
                }
                index={index}
                
                setRender={setRender}
              />


            )}
          </>
        
          <Notification notify={notify} setNotify={setNotify} />
      </div >
    
 
  );
};

export default PartWorkUsed;
